<template>
  <div class="corner-bd-box">
    <div class="wrapper">
      <slot />
    </div>
    <img src="@/assets/bigscreen/ruijin/corner_lt.png" class="corner corner-lt">
    <img src="@/assets/bigscreen/ruijin/corner_rt.png" class="corner corner-rt">
    <img src="@/assets/bigscreen/ruijin/corner_rb.png" class="corner corner-rb">
    <img src="@/assets/bigscreen/ruijin/corner_lb.png" class="corner corner-lb">
  </div>
</template>

<script>
export default {
  name: 'CornerBox'
}
</script>

<style lang="scss" scoped>
.corner-bd-box {
  position: relative;
  & > .wrapper {
    width: 100%;
    height: 100%;
    background-color: #0c2d5f;
  }
  & > .corner {
    position: absolute;
    z-index: 1;
    &.corner-lt {
      top: -1px;
      left: -1px;
    }
    &.corner-rt {
      top: -1px;
      right: -1px;
    }
    &.corner-rb {
      right: -1px;
      bottom: -1px;
    }
    &.corner-lb {
      bottom: -1px;
      left: -1px;
    }
  }
}
</style>
